<template>
  <div class="w-100 my-5 d-flex flex-column">
    <div class="my-5 row box-white vertical-center">
      <div class="col-sm m-2 vertical-center">
        <span :class="`font-bold alpha-07 ${isMobile ? 'font-15' : 'font-20'}`">{{ $t('qr_code_total') }}:&nbsp;&nbsp;</span>
        <span :class="`font-bold ${isMobile ? 'font-15' : 'font-25'} color-blue`">{{ wristbandStats ? getDecimalFormat(wristbandStats.qrCodeNumber || 0) : 0 }}</span>
      </div>
      <div class="col-sm m-2 vertical-center">
        <span :class="`font-bold alpha-07 ${isMobile ? 'font-15' : 'font-20'}`">{{ $t('tag') }}:&nbsp;&nbsp;</span>
        <input class="font-15" v-model="tag" />
      </div>
      <div class="col-sm m-2 vertical-center">
        <span :class="`font-bold alpha-07 ${isMobile ? 'font-15' : 'font-20'}`">{{ $t('quantity') }}:&nbsp;&nbsp;</span>
        <input class="font-15" maxlength="5" v-model="quantity" oninput="this.value = this.value.replace(/[^0-9]/g,'');" />
      </div>
      <div class="col-sm m-2 d-flex justify-content-end">
        <v-btn class="button-normal" @click="generateWristbandsTask">
          <span>{{ $t('generate_qr_codes') }}</span>
        </v-btn>
      </div>
    </div>
    <div :class="`my-2 row box-white d-flex justify-content-between vertical-center ${isMobile ? 'p-3' : 'p-7'}`" v-for="(item, index) in items" :key="(item, index)">
      <span :class="`col-sm font-bold ${isMobile ? 'mt-1 font-12' : 'font-15'}`">{{ item.tag }}</span>
      <span :class="`col-sm font-bold color-blue ${isMobile ? 'mt-1 font-12' : 'font-15'}`">{{ item.startNumber }}&nbsp;-&nbsp;{{ item.endNumber }}</span>
      <span :class="`col-sm font-bold ${isMobile ? 'mt-1 font-12' : 'font-15'}`">{{ getDecimalFormat(item.quantity) }}</span>
      <span :class="`col-sm alpha-07 ${isMobile ? 'my-1 font-12' : 'font-15'}`">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
      <v-btn class="button-normal" small @click="downloadPdf(item.downloadUrl)">
        <span>{{ $t('download') }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { functions, firestore } from '../../../main';
import { onSnapshot, collection } from 'firebase/firestore';
import { getDecimalFormat, getDateStringFromTimestamp, showLoading } from '../../../functions';

export default {
  name: 'SetHandlingFee',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    wristbandStats() {
      return this.$store.state.statsMap && this.$store.state.statsMap['wristband'] ? this.$store.state.statsMap['wristband'] : null;
    }
  },
  data() {
    return {
      items: [],
      tag: '',
      quantity: '',
      snapExcelLinkList: null
    }
  },
  mounted() {
    this.getExcelLinkListTask();
  },
  destroyed() {
    if (this.snapExcelLinkList) {
      this.snapExcelLinkList();
    }
  },
  methods: {
    getDecimalFormat,
    getDateStringFromTimestamp,
    downloadPdf(downloadUrl) {
      window.open(downloadUrl, '_blank');
    },
    getExcelLinkListTask() {
      if (this.snapExcelLinkList) {
        return;
      }
      const loader = showLoading(this, 1);
      this.snapExcelLinkList = onSnapshot(collection(firestore, 'stats', 'wristband', 'excelLink'), querySnapshot => {
        loader.hide();
        const items = [];
        querySnapshot.forEach(doc => items.push(doc.data()));
        items.sort((a, b) => (a.createdAt.seconds < b.createdAt.seconds) ? 1 : -1);
        this.items = items;
      });
    },
    generateWristbandsTask() {
      if (!this.tag) {
        this.$toast.error('Please enter Tag.');
        return;
      }
      if (!this.quantity) {
        this.$toast.error('Please enter Quantity.');
        return;
      }
      const quantity = Number.parseInt(this.quantity) || 0;
      if (quantity < 1 || quantity > 30000) {
        this.$toast.error('Please enter Quantity between 1 and 30000.');
        return;
      }
      const params = {
        functionName: 'generateWristbands',
        tag: this.tag,
        quantity: quantity
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>